const setScrollClass = () => {
    document.querySelector('header.head').classList.toggle('scrolled', window.scrollY)
}
window.addEventListener('scroll', () => setScrollClass());
window.addEventListener('load', () => setScrollClass());
